<template>
    <div class="order-detail-page full-height display-col">
        <full-con :canReturn="canReturn">
            <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/orders' }">订单管理</el-breadcrumb-item>
                <el-breadcrumb-item >账单</el-breadcrumb-item>
            </el-breadcrumb> -->
            <div slot="editBreadcrumb">
                <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
            </div>
            <div slot="full">
                <div class="order-detail-container full-height flex1">
                    <el-form>
                        <div class="tabel-container">
                            <el-row class="table-content">
                                <el-col :span="24" class="content">
                                    <el-row>
                                        <el-col :span="10" class="labelTitle"> <span class="el-icon-document">&nbsp;{{$t('OrderBill.OrderBill2')}}</span></el-col>
                                        <el-col :span="14" class="labelValue">{{paymentInfo.paymentNumber}}</el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10" class="labelTitle">{{$t('OrderBill.OrderBill1')}}</el-col>
                                        <el-col :span="14" class="labelValue">{{paymentInfo.orderType | paymentTypeFilter}}</el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10" class="labelTitle">{{$t('orderList.orderList2')}}</el-col>
                                        <el-col :span="14" class="labelValue">{{paymentInfo.orderNumber}}</el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>

                        <br>
                        <div class="tabel-container">
                            <template>
                                <el-table
                                        :data="paymentItemList"
                                        style="width: 100%">
                                    <el-table-column
                                            prop="configPayProjectId"
                                            :label="$t('OrderBill.OrderBill3')"
                                            width="180"
                                            :formatter="payProjectFormat">
                                    </el-table-column>
                                    <el-table-column
                                            prop="price"
                                            :label="$t('OrderBill.OrderBill4')"
                                            width="180"
                                            :formatter="priceShow">
                                    </el-table-column>
                                    <el-table-column
                                            prop="count"
                                            :label="$t('excel.excel7')">
                                    </el-table-column>
                                    <el-table-column
                                            prop="discountAmount"
                                            :label="$t('OrderBill.OrderBill5')">
                                    </el-table-column>
                                    <el-table-column
                                            :label="$t('OrderBill.OrderBill6')">
                                        <template slot-scope="scope">
                                            <div class="amountShow">
                                                <span class="span1" v-if="scope.row.receivedAmount!=scope.row.receivableAmount">{{'￥' + scope.row.receivableAmount}}</span>
                                                <span class="span2">{{'￥' + scope.row.receivedAmount}}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </div>
                        <br>
                        <div class="tabel-container">
                            <el-row class="table-content">
                                <el-col :span="24" class="content">
                                    <el-row>
                                        <el-col :span="10" class="labelTitle">{{$t('OrderBill.OrderBill7')}}</el-col>
                                        <el-col :span="14" class="labelValue">{{'￥'+paymentInfo.receivedAmount}}</el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10" class="labelTitle">{{$t('OrderBill.OrderBill8')}}</el-col>
                                        <el-col :span="14" class="labelValue">{{'￥'+paymentInfo.customerBalance}}</el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                        <br>
                        <div class="tabel-container">
                            <div style="text-align: center" v-if="isEditPage">
                                <el-button type="primary" @click="paymentPay" v-if="payBtn">{{$t('OrderBill.OrderBill10')}}</el-button>
                                <div v-if="payFail">
                                    <el-button type="info">{{$t('OrderBill.OrderBill9')}}</el-button><el-link :underline="false" style="margin-left: 10px" @click="toRecharge()">{{$t('OrderBill.OrderBill11')}}</el-link>
                                </div>
                            </div>
                        </div>
                    </el-form>

                </div>
            </div>
        </full-con>
    </div>
</template>

<script>
// import func from 'vue-editor-bridge';

    export default {
        data() {
            return {
                canReturn:'1',
                pageTitle:this.$t('orderList.orderList21'),
                orderId:'',
                isEditPage:'0',
                configPayProject:{},
                paymentInfo:{},
                paymentItemList:[],
                payBtn:true,
                payFail:false,
            }
        },
        methods: {
            //获取收费项目
            async getConfigPayProject(){
                const {data:res} = await this.$http.get('configPayProject/getAllConfigPayProject');
                this.configPayProject = res.data;
            },
            //获取账单信息
            async getOrderBill(){
                const {data:res} = await this.$http.get('order/payment/'+this.orderId);
                this.paymentInfo = res.data;
                this.paymentItemList=this.paymentInfo.paymentItemList;
            },
            async savePost(){
                const {data:res} = await this.$http.post('order/payment/pay',{id:this.paymentInfo.id});
                if(res.code == 200){
                    this.$message.success(res.message);
                    this.$router.go(-1);
                }
                else{
                    //余额不足
                    if(res.code == 1000){
                        this.payBtn=false;
                        this.payFail=true;
                    }else{
                        this.$message.error(res.message);
                    }
                }
            },//金额格式
            priceShow(row, column, cellValue, index){
                let ret = ''
                ret = '￥' + cellValue
                return ret
            },
            //收费项目格式
            payProjectFormat(row, column, cellValue, index){
                if(this.configPayProject.length>0){
                    let payProject=this.configPayProject.filter(function(item){
                        return item.value == cellValue;
                    });
                    let payProjectName='';
                    if(payProject && payProject.length>0){
                        payProjectName=payProject[0].name
                    }

                    return payProjectName;
                }
            },//支付账单
            paymentPay(){
                this.$confirm(this.$t('OrderBill.OrderBill12'), this.$t('prompt.title'), {
                    confirmButtonText: this.$t('confirm'),
                    confirmButtonClass:"form-btn btn-blue",
                    cancelButtonText: this.$t('cancel'),
                    cancelButtonClass:"form-btn btn-gray",
                    type: 'warning'
                }).then(
                    async () => {
                        const {data:res} = await this.$http.post('order/payment/pay',{id:this.paymentInfo.id});
                        if(res.code == 200){
                            this.$message.success(res.message);
                            this.$router.go(-1);
                        }
                        else{
                            //余额不足
                            if(res.code == 1000){
                                this.payBtn=false;
                                this.payFail=true;
                            }else{
                                this.$message.error(res.message);
                            }
                        }
                    }
                ).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('OrderBill.OrderBill13')
                    });
                });
            },//跳转充值
            toRecharge(){
                this.$router.push({
                    name:'recharge',
                })
            },
        },
        created(){
            this.orderId = this.$route.query.id;
            this.isEditPage = this.$route.query.isEdit == '0' ? false : true;
            this.getConfigPayProject();
            this.getOrderBill();
        }
    }
</script>

<style lang="less" scoped>
    .order-detail-container{
        background: #fff;
        padding: 20px;
    }
    ul,li{
        list-style: none;
    }
    .labelTitle{
        text-align: left;
    }
    .labelValue{
        text-align: right;
    }
    .table-title{
        padding: 5px 0;
        text-align: center;
        background: #F1F2F6;
    }
    .table-content .content .el-col{
        height: 35px;
        line-height: 30px;
        padding: 0 2px;
        border-bottom: 1px solid #E5E9F8;
        // white-space:nowrap;
        // text-overflow:ellipsis;
        overflow:auto;
    }
    .el-form-item{
        margin-bottom: 0 !important;
    }
    /deep/.el-form-item__content{
        line-height: 30px !important;
    }
    /deep/ .el-icon-document{
        font-size:17px;
    }
    .amountShow span{
        display: block;
        color: red;
    }
    .amountShow .span1{
        text-decoration:line-through;
        color:#333333;
        text-decoration-color: red;
    }
    // .table-content .content{
    //   padding-bottom: 10px;
    // }

</style>>

